export default {
      id: "chart-line-usage",
      viewBox: "0 0 21 12",
      url: __webpack_public_path__ + "img/icons.svg#chart-line",
      toString: function () {
        return this.url;
      }
    }